import { DatastoreProvider, InstanceStack } from 'component/navigation/instance';
import { useInstanceConfig } from 'data/instance-config';
import { useLocalSearchParams } from 'expo-router';
import { loginModuleQuery } from 'system/structure-modules';

/** Mounts the login structure, which the blocked screen belongs to. */
export default function SuspendedLayout() {
    const { siloKey } = useLocalSearchParams<'/[siloKey]/suspended'>();
    const instanceConfig = useInstanceConfig({
        siloKey,
        structureKey: 'login',
        instanceKey: 'one',
        moduleQuery: loginModuleQuery,
    });

    return (
        <DatastoreProvider {...instanceConfig}>
            <InstanceStack />
        </DatastoreProvider>
    );
}
